import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space, Select } from "antd";
import { SearchOutlined, FileProtectOutlined, EditOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../services/http";
import dayjs from "dayjs";

const options_status = [
  { value: 0, label: "Aguardando" },
  { value: 1, label: "Finalizado" },
];

export const Avaliacoes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // ID ALTERAÇÃO
  const [search, setSearch] = useState("");
  const [filtroStatus, setFiltroStatus] = useState(0);

  useEffect(() => {
    listarAvaliacoesFormularios();
  }, []);

  // LISTAR
  const listarAvaliacoesFormularios = async () => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios_lancamento/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "avaliacao",
      title: "Avaliação",
      sorter: (a, b) => a.avaliacao?.localeCompare(b.avaliacao),
    },
    {
      dataIndex: "ano",
      title: "Ano",
      sorter: (a, b) => a.ano?.toString()?.localeCompare(b.ano?.toString()),
    },
    {
      dataIndex: "colaborador",
      title: "Colaborador Avaliado",
      sorter: (a, b) => a.colaborador?.localeCompare(b.colaborador),
    },
    {
      key: "data_realizacao",
      title: "Data Realização",
      render: (_, e) => (e.data_realizacao ? dayjs(e.data_realizacao).format("DD/MM/YYYY") : "-"),
      sorter: (a, b) =>
        dayjs(a.data_realizacao).format("DD/MM/YYYY")?.localeCompare(dayjs(b.data_realizacao).format("DD/MM/YYYY")),
    },
    {
      key: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Avaliado" : "Aguradando Avaliação"),
      sorter: (a, b) =>
        (a.status === 1 ? "Avaliado" : "Aguradando Avaliação")?.localeCompare(
          b.status === 1 ? "Avaliado" : "Aguradando Avaliação"
        ),
    },
    {
      key: "acoes",
      title: "Ações",
      width: 60,
      render: (_, e) =>
        e.status === 0 ? (
          <Space.Compact>
            <Tooltip title="Realizar">
              <Button
                loading={loading}
                onClick={() => navigate(`/avaliacoes/lancamento/${e.id}`)}
                icon={<EditOutlined />}
              />
            </Tooltip>
          </Space.Compact>
        ) : (
          <Space.Compact>
            <Tooltip title="Detalhes">
              <Button
                loading={loading}
                onClick={() => navigate(`/avaliacoes/lancamento/${e.id}`)}
                icon={<UnorderedListOutlined />}
              />
            </Tooltip>
          </Space.Compact>
        ),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, filtro_status) => {
    let filteredData = dados?.filter(
      (val) =>
        val.avaliacao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.ano?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData.filter((e) => e.status === filtro_status);
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, filtroStatus) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Minhas Avaliações"
              subtitle="Avaliações pendetes para realização"
              icon={<FileProtectOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Select
                  style={{ minWidth: 180 }}
                  value={filtroStatus}
                  onChange={(e) => setFiltroStatus(e)}
                  options={options_status}
                />
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                rowKey="id"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
